export const EditableIllustration = () => (
  <svg
    width='400'
    height='300'
    viewBox='0 0 400 300'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='400' height='300' fill='#EDF2F7' />
    <path
      d='M53 116C53 112.686 55.6863 110 59 110H341C344.314 110 347 112.686 347 116V149C347 152.314 344.314 155 341 155H59C55.6863 155 53 152.314 53 149V116Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M59 106H341C346.523 106 351 110.477 351 116V149C351 154.523 346.523 159 341 159H59C53.4771 159 49 154.523 49 149V116C49 110.477 53.4772 106 59 106ZM59 110C55.6863 110 53 112.686 53 116V149C53 152.314 55.6863 155 59 155H341C344.314 155 347 152.314 347 149V116C347 112.686 344.314 110 341 110H59Z'
      fill='#38B2AC'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M71 132.5C71 130.015 73.0147 128 75.5 128H196.5C198.985 128 201 130.015 201 132.5C201 134.985 198.985 137 196.5 137H75.5C73.0147 137 71 134.985 71 132.5Z'
      fill='#A0AEC0'
    />
    <path
      d='M278.211 143H277.404C277.181 143 277 142.795 277 142.543C277 142.291 277.181 142.087 277.404 142.087H278.212C278.88 142.087 279.423 141.472 279.423 140.717V124.283C279.423 123.528 278.88 122.913 278.212 122.913L277.404 122.913C277.181 122.913 277 122.709 277 122.457C277 122.204 277.181 122 277.404 122H278.212C279.325 122 280.231 123.024 280.231 124.283V140.717C280.231 141.975 279.324 143 278.211 143Z'
      fill='#4A5568'
    />
    <path
      d='M282.25 143H281.442C280.329 143 279.423 141.975 279.423 140.717V124.283C279.423 123.024 280.329 122 281.442 122H282.25C282.473 122 282.654 122.205 282.654 122.457C282.654 122.709 282.473 122.913 282.25 122.913H281.442C280.774 122.913 280.231 123.528 280.231 124.283V140.717C280.231 141.473 280.774 142.087 281.442 142.087H282.25C282.473 142.087 282.654 142.291 282.654 142.543C282.654 142.795 282.473 143 282.25 143Z'
      fill='#4A5568'
    />
    <path
      d='M281.442 132.956H278.211C277.988 132.956 277.807 132.752 277.807 132.5C277.807 132.248 277.988 132.043 278.211 132.043H281.442C281.665 132.043 281.846 132.248 281.846 132.5C281.846 132.752 281.665 132.956 281.442 132.956Z'
      fill='#4A5568'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M209 143C208.448 143 208 142.552 208 142L208 123C208 122.448 208.448 122 209 122C209.552 122 210 122.448 210 123L210 142C210 142.552 209.552 143 209 143Z'
      fill='#4A5568'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M53 97.5C53 95.0147 55.0147 93 57.5 93H108.5C110.985 93 113 95.0147 113 97.5C113 99.9853 110.985 102 108.5 102H57.5C55.0147 102 53 99.9853 53 97.5Z'
      fill='#A0AEC0'
    />
    <path
      d='M249 168C249 165.239 251.239 163 254 163H289C291.761 163 294 165.239 294 168V203C294 205.761 291.761 208 289 208H254C251.239 208 249 205.761 249 203V168Z'
      fill='#CBD5E0'
    />
    <path
      d='M269.125 188.942L279.416 179L281 180.529L269.125 192L262 185.118L263.583 183.589L269.125 188.942Z'
      fill='#4A5568'
    />
    <path
      d='M302 168C302 165.239 304.239 163 307 163H342C344.761 163 347 165.239 347 168V203C347 205.761 344.761 208 342 208H307C304.239 208 302 205.761 302 203V168Z'
      fill='#CBD5E0'
    />
    <path
      d='M318.256 191.507C318.092 191.671 318 191.893 318 192.125C318 192.358 318.092 192.58 318.256 192.744C318.421 192.908 318.643 193 318.875 193C319.107 193 319.33 192.908 319.494 192.744L324.897 187.342C324.91 187.328 324.926 187.317 324.944 187.31C324.962 187.303 324.981 187.299 325 187.299C325.019 187.299 325.038 187.303 325.056 187.31C325.074 187.317 325.09 187.328 325.103 187.342L330.506 192.745C330.587 192.826 330.684 192.891 330.79 192.935C330.896 192.979 331.01 193.001 331.125 193.001C331.24 193.002 331.354 192.979 331.46 192.935C331.566 192.891 331.662 192.827 331.744 192.745C331.825 192.664 331.889 192.568 331.933 192.461C331.977 192.355 332 192.242 332 192.127C332 192.012 331.978 191.898 331.934 191.792C331.89 191.686 331.825 191.589 331.744 191.508L326.342 186.103C326.328 186.09 326.317 186.074 326.31 186.056C326.303 186.038 326.299 186.019 326.299 186C326.299 185.981 326.303 185.962 326.31 185.944C326.317 185.926 326.328 185.91 326.342 185.897L331.745 180.494C331.909 180.33 332.001 180.107 332.001 179.875C332.001 179.642 331.909 179.42 331.744 179.256C331.58 179.092 331.357 179 331.125 179C330.893 179 330.67 179.092 330.506 179.257L325.103 184.658C325.09 184.672 325.074 184.683 325.056 184.69C325.038 184.697 325.019 184.701 325 184.701C324.981 184.701 324.962 184.697 324.944 184.69C324.926 184.683 324.91 184.672 324.897 184.658L319.494 179.257C319.413 179.175 319.316 179.111 319.21 179.067C319.104 179.023 318.99 179 318.875 179C318.643 179 318.421 179.092 318.256 179.256C318.092 179.42 318 179.643 318 179.875C318 180.107 318.092 180.33 318.256 180.494L323.658 185.897C323.672 185.91 323.683 185.926 323.69 185.944C323.697 185.962 323.701 185.981 323.701 186C323.701 186.019 323.697 186.038 323.69 186.056C323.683 186.074 323.672 186.09 323.658 186.103L318.256 191.507Z'
      fill='#4A5568'
    />
  </svg>
)
